import { render, staticRenderFns } from "./RemoveConfirmHeadDept.vue?vue&type=template&id=13e274a6"
import script from "./RemoveConfirmHeadDept.vue?vue&type=script&lang=js"
export * from "./RemoveConfirmHeadDept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports